export { default as TierAllIcon } from './all.svg';
export { default as TierWhaleIcon } from './whale.svg';
export { default as TierSharkIcon } from './shark.svg';
export { default as TierStarterIcon } from './starter.svg';
